module.exports = __webpack_public_path__ + "static/media/fill_63@3x.a915e864.png";